import React from 'react';
import { DropdownSelector } from 'hyperdb-utils';

const OriginSelector = ({ value, onChange, required = false }) => {
  const origins = [
    'PMS',
    'Rentals United',
    'Icnea',
    'VRBO',
    'Abritel',
    'Spain Holiday',
    'Owners Direct',
    'Phone Request',
    'Holidays Lettings',
    'Contact Form',
    'Homelidays',
    'BCN.net',
    'BCN.com',
    'Vacationrentals411',
    'Booking',
    'Online Booking',
    'LeRoutard.com',
    'niumba',
    'Online Request',
    'HomeAway',
    'abritel.fr',
    'vrbo/abritel',
    'homeaway.com',
    'homeaway.co.uk',
    'fewo-direkt.de',
    'homeaway.it',
    'Craigslist',
    'Flipkey',
    'Airbnb',
    'Amivac',
    'Perfect Places',
    'Abritel Online',
    'Vacation Home Rentals',
  ];
  origins.sort((a, b) => a.localeCompare(b));

  return (
    <DropdownSelector
      label={ `Origin ${ required ? ' *' : '' }` }
      name="origin"
      value={ value }
      options={ origins.map(o => ({ name: o, value: o })) }
      onChange={ onChange }
    />
  );
};

export default OriginSelector;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/OriginSelector.jsx